import { isDarkColor } from "./is-dark-color";
export var isLightColor = function isLightColor(color) {
  return !isDarkColor(color);
};